import CAxios from "./CAxios";
import { message } from "antd";
import cookie from "react-cookies";

export const toAddUser = async (email, ids, sales, dso, pp) => {
  const { data } = await CAxios.post(`/api/user/add`, {
    email: email,
    ids: ids,
    sales: sales,
    dso: dso,
    pp: pp,
  });

  if (data.status == 303) {
    message.error({
      content: "This email has already been registered!",
    });
    return;
  }
  return data.success && data.success.user ? data.success.user : null;
};

export const toGetUsers = async () => {
  const { data } = await CAxios.post(`/api/user/list`);

  return data.success && data.success.users
    ? JSON.parse(data.success.users)
    : [];
};

export const toGetUsersAll = async () => {
  const { data } = await CAxios.post(`/api/user/all`);

  return data.success && data.success.users
    ? JSON.parse(data.success.users)
    : [];
};

export const toUpdateCountriesInUser = async (id, ids) => {
  const { data } = await CAxios.post(`/api/user/country/update`, {
    id: id,
    ids: ids,
  });

  return data.success ? data.success : [];
};

export const toChangeStatus = async (email) => {
  const { data } = await CAxios.post(`/api/user/status`, { email: email });

  return data.success && data.success.res ? JSON.parse(data.success.res) : [];
};

export const toChangeSales = async (email) => {
  const { data } = await CAxios.post(`/api/user/sales`, { email: email });

  return data.success && data.success.res ? JSON.parse(data.success.res) : [];
};

export const toChangeDSO = async (email) => {
  const { data } = await CAxios.post(`/api/user/dso`, { email: email });

  return data.success && data.success.res ? JSON.parse(data.success.res) : [];
};

export const toChangePP = async (email) => {
  const { data } = await CAxios.post(`/api/user/pp`, { email: email });

  return data.success && data.success.res ? JSON.parse(data.success.res) : [];
};

export const getListOfInputs = async () => {
  const { data } = await CAxios.post(`/api/inputs/list`);

  return data.success && data.success.inputs ? data.success.inputs : [];
};

export const getInputs = async () => {
  const { data } = await CAxios.post(`/api/inputs/all`);

  return data.success && data.success.res ? data.success.res : [];
};

export const getListTemplates = async (countryId) => {
  const { data } = await CAxios.post(`/api/templates/all`, {
    countryId: countryId,
  });
  return data.success && data.success.templates ? data.success.templates : [];
};

export const getListTemplatesUser = async () => {
  const { data } = await CAxios.post(`/api/templates/user`);
  return data.success && data.success.templates ? data.success.templates : [];
};

export const toUpdateName = async (id, name) => {
  const { data } = await CAxios.post(`/api/template/name/update`, {
    id: id,
    name: name,
  });
  return data.success && data.success.template ? data.success.template : [];
};

export const toDeleteTemplate = async (id) => {
  const { data } = await CAxios.post(`/api/template/delete`, { id: id });
  return data.success && data.success.res ? data.success.res : null;
};

export const toUpdateTemplate = async (
  id,
  datas,
  indicators,
  selectedChoice,
  countryId,
  dso,
) => {
  const { data } = await CAxios.post(`/api/template/update`, {
    id: id,
    data: datas,
    indicators: indicators,
    choice: selectedChoice,
    countryId: countryId,
    dso: dso,
  });
  return data.success && data.success.template ? data.success.template : [];
};

export const toCreateTemplate = async (
  datas,
  indicators,
  selectedChoice,
  countryIds,
  name,
  dso,
) => {
  const { data } = await CAxios.post(`/api/template/create`, {
    data: datas,
    indicators: indicators,
    choice: selectedChoice,
    countryIds: countryIds,
    name: name,
    dso,
  });
  return data.success && data.success.template ? data.success.template : [];
};

export const toSaveCurrency = async (countryId, currencyId, currencyValue) => {
  const { data } = await CAxios.post(`/api/currency/add`, {
    countryId: countryId,
    currencyId: currencyId,
  });
  return data.success && data.success.currency ? data.success.currency : [];
};

export const toGetCurrencies = async (countryId) => {
  const { data } = await CAxios.post(`/api/currency/list`, {
    countryId: countryId,
  });
  return data.success && data.success.currencies ? data.success.currencies : [];
};

export const toAddAssessment = async (
  values,
  calculatedValues,
  clinicId,
  doctorId,
  status,
) => {
  const { data } = await CAxios.post(`/api/assessment/add`, {
    data: values,
    calculatedValues: calculatedValues,
    clinicId: clinicId,
    doctorId: doctorId,
    status,
  });
  return data.success && data.success.Assessment
    ? data.success.Assessment
    : null;
};

export const toUpdateAssessment = async (
  values,
  calculatedValues,
  clinicId,
  doctorId,
  status,
) => {
  const { data } = await CAxios.post(`/api/assessment/update`, {
    data: values,
    calculatedValues,
    clinicId: clinicId,
    doctorId: doctorId,
    status: status,
  });
  return data.success && data.success.Assessment
    ? data.success.Assessment
    : null;
};

export const getSetting = async () => {
  const { data } = await CAxios.post(`/api/settings/get`);
  return data.success && data.success.setting ? data.success.setting : null;
};

export const toSendEmail = async (product, message) => {
  const { data } = await CAxios.post(`/api/email/send`, {
    subject: product,
    body: message,
  });
  return data.success && data.success.email ? data.success.email : null;
};

export const toAddUpdateSettings = async (templateId) => {
  const { data } = await CAxios.post(`/api/settingsuser/update`, {
    templateId: templateId,
  });
  return data.success && data.success.res ? data.success.res : null;
};

export const toGetSettingsUser = async () => {
  const { data } = await CAxios.post(`/api/settingsuser/get`);

  return data.success && data.success.settings ? data.success.settings : [];
};

export const togetCurrentUser = async () => {
  const { data } = await CAxios.post(`/api/current/user`);

  return data.success ? data.success : [];
};

export const toLogout = async () => {
  const { data } = await CAxios.post(`/user/logout`);

  return true;
};

export const toDeleteAssessment = async (id) => {
  const { data } = await CAxios.post(`/api/assessment/delete`, { id: id });
  return data.success && data.success.res ? data.success.res : null;
};

export const toGetListOfAssessment = async (
  rowsPerPage,
  searchText,
  filter,
  pageNb,
  language,
  all,
) => {
  const { data } = await CAxios.post(`/api/assessment/list`, {
    rowsPerPage,
    searchText,
    filter,
    pageNb,
    language,
    all,
  });
  return data.success && data.success.res ? data.success.res : [];
};

export const toGetDetailAssessment = async (id) => {
  const { data } = await CAxios.post(`/api/assessment/detail`, { id: id });
  return data.success && data.success.res ? data.success.res : null;
};

export const toGetListOfAssessmentUser = async () => {
  const { data } = await CAxios.post(`/api/assessment/user`);
  return data.success && data.success.res ? data.success.res : [];
};

export const toGenerateGmailToken = async (code) => {
  const { data } = await CAxios.post(`/api/token/update`, { code: code });
  return data.success && data.success.res ? data.success.res : [];
};

export const toGetAccountsAndContacts = async (code) => {
  const { data } = await CAxios.post(`/api/sf/login`, { code: code });
  return data.success && data.success ? data.success : [];
};

export const getClinicsApi = async () => {
  // TODO: Refactor this function

  return [];
  const { data } = await CAxios.post(`/api/sf/all`, {
    token: cookie.load("tokenSF"),
  });
  return data.success && data.success ? data.success : [];
};
